// extracted by mini-css-extract-plugin
export default {"submit-button":"KZTqX42_","form-submitting":"_x0figqt","has-icon":"f35TC5vx","icon-only":"hcWQW6Ew"};